module.exports = __webpack_public_path__ + "img/david-matausek.5b7cdc2b.jpg";